import { CludoContext, CludoContextConfig } from 'ui/contexts/CludoContext';
import { useSearchDictionary } from '3-foundation/Search/useSearchDictionary';
import { useApplicationContext } from '3-foundation/Application/ApplicationContext';
import { getEngineId } from '3-foundation/Search/getEngineId';
import { getSearchSiteId } from '3-foundation/Search/getSearchSiteId';
import { useSiteContext } from '3-foundation/Site/SiteContext';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';

const DynamicSearchInput = dynamic(
	() => import('ui/components/10-vendors/cludo/CludoSearchResults/Components/SearchInput').then((module) => module.UI_SearchInput),
	{
		ssr: false,
	},
);

interface SearchInputProps {
	labelledById: string;
	noMargin?: boolean;
	initialQuery?: string | null;
}

export const SearchInput = ({ labelledById, noMargin, initialQuery }: SearchInputProps) => {
	const dictionaryCollection = useSearchDictionary();
	const applicationContext = useApplicationContext();
	const siteContext = useSiteContext();
	const router = useRouter();

	const handleSearch = (query: string) => {
		if (siteContext?.settings?.searchSettings?.searchUrl) {
			router.push(`${siteContext.settings.searchSettings.searchUrl}?query=${encodeURIComponent(query)}`);
		}
	};

	const { locale } = router;
	const cludoLanguage = locale as 'da' | 'en' | 'kl-gl';
	const cludoConfiguration: CludoContextConfig = {
		customerId: Number(applicationContext?.envVars?.NEXT_PUBLIC_SEARCH_CLUDO_CLIENT_ID),
		engineId: getEngineId({
			daEngine: applicationContext?.envVars?.NEXT_PUBLIC_SEARCH_CLUDO_ENGINE_DA as string,
			enEngine: applicationContext?.envVars?.NEXT_PUBLIC_SEARCH_CLUDO_ENGINE_EN as string,
			klEngine: applicationContext?.envVars?.NEXT_PUBLIC_SEARCH_CLUDO_ENGINE_KL as string,
			locale: cludoLanguage,
		}),
		siteid: getSearchSiteId(siteContext.root.id),
		locale: cludoLanguage,
	};

	return (
		<CludoContext config={cludoConfiguration}>
			<DynamicSearchInput
				dictionary={dictionaryCollection}
				labelledById={labelledById}
				noMargin={noMargin}
				onSearch={handleSearch}
				initialQuery={initialQuery}
			/>
		</CludoContext>
	);
};
